import { Box, Typography } from '@mui/material'
import React from 'react'
import { Motion } from './Motion';
import { fullCenter, pastelOrange } from '../Pages/Main/constants';

export default function Button({ text, white = false, sx = {}, onClick = () => { console.error("Button on click not set! " + text) }, sxText = {} }) {
    return (
        <Motion scale={1}>
            <Box sx={{
                border: white ? '2px solid #EDF1F3' : 'none', borderRadius: '24px',
                bgcolor: white ? "white" : pastelOrange, cursor: 'pointer', width: '100%', height: '46px', display: 'flex', ...fullCenter, ...sx,
            }} onClick={onClick}>
                {text && <Typography variant='button_text' sx={{ color: white ? '#6C7278' : 'white', fontWeight: 'bold', ...sxText }}>{text}</Typography>}
            </Box>
        </Motion>
    )
}
